<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORES.SETTINGS_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x4 sp-store-details-general-settings__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-status-indicator
      [label]="'STORES.IN_STORE_ENABLED_DISABLE_CTA'"
      [status_class]="getCompanySettingsBackgroundClass(store?.order_requirements?.is_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.WEB_SALES_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(store?.order_requirements?.is_web_sale_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.IN_STORE_SALES_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(store?.order_requirements?.is_in_store_sale_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.ON_SESSION_SALES_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(store?.order_requirements?.is_on_session_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.OFF_SESSION_SALES_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(store?.order_requirements?.is_off_session_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'COMPANIES.BNPL_LONG_TITLE'"
      [status_class]="getCompanySettingsBackgroundClass(store?.order_requirements?.is_bnpl_long_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.IN_STORE_REVIEW_ENABLED_CTA'"
      [status_class]="getCompanySettingsBackgroundClass(store?.order_requirements?.is_store_review_disabled || false)">
    </app-shared-status-indicator>
    <app-shared-info
      [label]="'STORES.MIN_AMOUNT_LABEL'"
      [content]="getFormattedAmount(store?.order_requirements?.min_amount)"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.MAX_AMOUNT_LABEL'"
      [content]="getFormattedAmount(store?.order_requirements?.max_amount)"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2"></div>
</div>
